import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import loader from '../../../assets/img/loading.gif';

const LoadingModal = (props) => (
  <Modal isOpen={props.isOpen} centered={true} size="sm">
    <ModalBody>
      <div style={{textAlign: 'center'}}>
        <img src={loader} style={{height: 75, width: 75}} />
        <h5>Loading...</h5>
      </div>
    </ModalBody>
  </Modal>
);

export default LoadingModal;



// WEBPACK FOOTER //
// ./src/components/Modal/LoadingModal/LoadingModal.js